import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ScrollableList from "../../../../components/ScrollableList";

import {
    faChevronLeft,
    faChevronRight
} from "@fortawesome/free-solid-svg-icons";


export default function DwgNavigator({
    entities,
    selectedEntity,
    onSelect,
    category
})
{
    const [expanded, setExpanded] =
            useState(true);


    const safeEntities =
            entities || [];


    /**********************************************************
     * Styles
     **********************************************************/

    const navigatorDrawer =
    {
        position: "absolute",

        top: 0,
        right: 0,
        bottom: 0,

        width:
            expanded
                ? "320px"
                : "48px",

        display: "flex",
        flexDirection: "column",

        background:
            "linear-gradient(160deg, rgba(8,12,18,0.98) 0%, rgba(20,27,38,0.97) 55%, rgba(5,8,13,0.99) 100%)",

        borderLeft:
            "1px solid rgba(255,255,255,0.12)",

        boxShadow:
            "-15px 0 45px rgba(0,0,0,0.22)",

        backdropFilter:
            "blur(20px)",

        WebkitBackdropFilter:
            "blur(20px)",

        overflow: "hidden",

        transition:
            "width 0.25s ease",

        zIndex: 50
    };
	
	
	const navigatorTitleRow =
	{
	    display: "flex",
	    alignItems: "center",
	    gap: "10px",

	    marginBottom: "12px"
	};
	
	const navigatorHeader =
	{
	    padding:
	        "18px 20px 16px 20px",

	    borderBottom:
	        "1px solid rgba(255,255,255,0.08)"
	};


	const collapseButton =
	{
	    width: "28px",
	    height: "28px",

	    minWidth: "28px",

	    display: "flex",
	    alignItems: "center",
	    justifyContent: "center",

	    borderRadius: "50%",

	    background:
	        "rgba(255,255,255,0.08)",

	    border:
	        "1px solid rgba(255,255,255,0.12)",

	    color: "white",

	    fontSize: "12px",

	    cursor: "pointer",

	    transition:
	        "all 0.2s ease"
	};

    const navigatorTitle =
    {
        color: "white",

        fontSize: "11px",

        fontWeight: "700",

        letterSpacing: "2px",

        opacity: 0.55,

        marginBottom: "10px"
    };


    const categorySelector =
    {
        width: "100%",

        padding: "12px 14px",

        border:
            "1px solid rgba(255,255,255,0.12)",

        borderRadius: "12px",

        background:
            "linear-gradient(135deg, rgba(255,255,255,0.12), rgba(255,255,255,0.05))",

        color: "white",

        fontSize: "14px",

        fontWeight: "600",

        outline: "none"
    };


    const entityList =
    {
        flex: 1,

        overflowY: "auto",

        overflowX: "hidden",

        padding: "12px"
    };


    const entityRow =
    {
        display: "flex",

        alignItems: "center",

        justifyContent: "space-between",

        padding: "12px 14px",

        marginBottom: "6px",

        borderRadius: "12px",

        cursor: "pointer",

        fontSize: "13px",

        transition:
            "all 0.18s ease"
    };


    const entityCount =
    {
        padding:
            "12px 20px 18px 20px",

        color:
            "rgba(255,255,255,0.4)",

        fontSize: "11px",

        borderTop:
            "1px solid rgba(255,255,255,0.07)"
    };


    /**********************************************************
     * Select Entity
     **********************************************************/

    function selectEntity(
            entity)
    {
        if(onSelect == null)
        {
            return;
        }


        onSelect(
                entity);
    }


	/**********************************************************
	 * Render
	 **********************************************************/

	return (

	    <div style={navigatorDrawer}>


	        {/*
	         * Collapsed Navigator
	         */}

	        {!expanded &&
	            <div
	                style={{
	                    ...collapseButton,

	                    margin:
	                        "18px auto"
	                }}

	                onClick={() =>
	                    setExpanded(
	                        true)
	                }
	            >

	                <FontAwesomeIcon
	                    icon={
	                        faChevronLeft
	                    }
	                />

	            </div>
	        }


	        {/*
	         * Expanded Navigator
	         */}

	        {expanded &&
	            <>

	                {/*
	                 * Header
	                 */}

	                <div style={navigatorHeader}>


	                    {/*
	                     * Title / Collapse
	                     */}

	                    <div style={navigatorTitleRow}>

	                        <div
	                            style={collapseButton}

	                            onClick={() =>
	                                setExpanded(
	                                    false)
	                            }
	                        >

	                            <FontAwesomeIcon
	                                icon={
	                                    faChevronRight
	                                }
	                            />

	                        </div>


	                        <div
	                            style={{
	                                ...navigatorTitle,

	                                marginBottom:
	                                    0
	                            }}
	                        >
	                            DRAWING NAVIGATOR
	                        </div>

	                    </div>


	                    {/*
	                     * Category Selector
	                     */}

	                    <select
	                        style={categorySelector}

	                        value={
	                            category ||
	                            "DESKS"
	                        }

	                        onChange={() => {}}
	                    >

	                        <option
	                            value={
	                                category ||
	                                "DESKS"
	                            }
	                        >
	                            {
	                                category ||
	                                "DESKS"
	                            }
	                        </option>

	                    </select>

	                </div>
					<div style={{marginLeft:'10px', width:'calc(100% - 20px)', paddingTop:'10px'}}>
						<ScrollableList height="calc(100vh - 200px)">
		                {/*
		                 * Entities
		                 */}
	
			                <div style={entityList}>
		
			                    {safeEntities.map(
			                        (entity, index) =>
			                        {
			                            const selected =
			                                    selectedEntity != null &&
			                                    selectedEntity.name ===
			                                        entity.name;
		
		
			                            return (
		
			                                <div
			                                    key={
			                                        entity.autodeskId ||
			                                        entity.name ||
			                                        index
			                                    }
		
			                                    onClick={() =>
			                                        selectEntity(
			                                            entity)
			                                    }
		
			                                    style={{
			                                        ...entityRow,
		
			                                        background:
			                                            selected
			                                                ? "linear-gradient(135deg, #168cff 0%, #0067dc 100%)"
			                                                : "rgba(255,255,255,0.035)",
		
			                                        border:
			                                            selected
			                                                ? "1px solid rgba(255,255,255,0.24)"
			                                                : "1px solid transparent",
		
			                                        boxShadow:
			                                            selected
			                                                ? "0 8px 24px rgba(0,100,220,0.30)"
			                                                : "none",
		
			                                        color:
			                                            selected
			                                                ? "white"
			                                                : "rgba(255,255,255,0.80)"
			                                    }}
			                                >
		
			                                    <span>
			                                        {entity.name}
			                                    </span>
		
		
			                                    <span
			                                        style={{
			                                            opacity:
			                                                0.35,
		
			                                            fontSize:
			                                                "10px"
			                                        }}
			                                    >
		
			                                        {
			                                            entity.autodeskId != null
			                                                ? entity.autodeskId
			                                                : entity.category
			                                        }
		
			                                    </span>
		
			                                </div>
			                            );
			                        })
			                    }
		
			                </div>
						</ScrollableList>
					</div>
	                {/*
	                 * Footer
	                 */}

	                <div style={entityCount}>

	                    {safeEntities.length}

	                    {" "}

	                    {category || "ENTITIES"}

	                    {" FOUND"}

	                </div>

	            </>
	        }

	    </div>
	);
}